// extracted by mini-css-extract-plugin
export default {"root":"HomeAvatars_root__2cY6h","layout-container":"HomeAvatars_layout-container__YSa9R","pageSubtitle":"HomeAvatars_pageSubtitle__c2wz0","avatars":"HomeAvatars_avatars__60e76","container":"HomeAvatars_container__plVV-","textContainer":"HomeAvatars_textContainer__p0AVf"};
    if(module.hot) {
      // 1763446807827
      var cssReload = require("/usr/src/app/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  